import { useState, useCallback } from 'react';
import { message } from 'antd';
import { m310Api, M310ReportRow, M310ReportParams } from '../../../services/m310Api';

export function useM310Report() {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState<M310ReportRow[]>([]);
  const [total, setTotal] = useState(0);

  const [startLoc, setStartLoc]     = useState('');
  const [endLoc, setEndLoc]         = useState('');
  const [startProd, setStartProd]   = useState('');
  const [endProd, setEndProd]       = useState('');
  const [startBatch, setStartBatch] = useState('');
  const [endBatch, setEndBatch]     = useState('');
  const [startDate, setStartDate]   = useState('');
  const [endDate, setEndDate]       = useState('');

  const handleQuery = useCallback(async () => {
    setLoading(true);
    try {
      const params: M310ReportParams = {
        startLoc:   startLoc   || undefined,
        endLoc:     endLoc     || undefined,
        startProd:  startProd  || undefined,
        endProd:    endProd    || undefined,
        startBatch: startBatch || undefined,
        endBatch:   endBatch   || undefined,
        startDate:  startDate  || undefined,
        endDate:    endDate    || undefined,
      };
      const res = await m310Api.getReport(params);
      setRecords(res.items || []);
      setTotal(res.total || 0);
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : '查詢失敗';
      message.error(errorMessage);
      setRecords([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [startLoc, endLoc, startProd, endProd, startBatch, endBatch, startDate, endDate]);

  return {
    loading,
    records,
    total,
    startLoc, setStartLoc,
    endLoc, setEndLoc,
    startProd, setStartProd,
    endProd, setEndProd,
    startBatch, setStartBatch,
    endBatch, setEndBatch,
    startDate, setStartDate,
    endDate, setEndDate,
    handleQuery,
  };
}
